import React from 'react';
import { useSelector } from 'react-redux';
import { selectTint } from './modules/tint';
import { selectConfig } from './modules/config';
import { TintWrapper } from './services/tint-wrapper';
import useTint from './hooks/use-tint';
import { IConfig } from '../../url-reader';
import { MessageService } from '../../message-service';
import Head from './components/head/head';
import ThemeWrapper from './components/theme-wrapper/theme-wrapper';
import { globalConfig } from '../../shared/config/config';
import ErrorMessage from '../../shared/components/error-message/error-message';
import Loader from '../../shared/components/loader/loader';
import { IPersonalization } from '../../shared/types/Personalization';
import { ISocialFeedsGroupedItem, SocialFeedsTypesMap } from '../../shared/mappers/map-social-feeds';
import { ITintMeta } from '../../shared/services/tint.service';
import useTitle from './hooks/use-title';
import { Nullable } from '../../shared/types/Typescript-utils';
import useCreatePopup from './hooks/use-create-popup';

export interface ITheme {
  personalization: IPersonalization;
  socialFeeds: SocialFeedsTypesMap<readonly ISocialFeedsGroupedItem[]>;
  meta: ITintMeta;
  config: IConfig;
  customFontSecondary?: Nullable<string>;
  customFontPopup?: Nullable<string>;
}

TintWrapper.setTint();
const App = () => {
  useTint();
  useTitle();

  const tintSelector = useSelector(selectTint);
  const config = useSelector(selectConfig);
  useCreatePopup(config?.config);

  if (tintSelector.error) {
    MessageService.send({
      type: globalConfig.postMessage.actions.themeFailed,
      tintSlug: config.config ? config.config.tintSlug : '',
    });
    return <ErrorMessage />;
  }

  if (!tintSelector.personalization || !tintSelector.socialFeeds || !tintSelector.meta || !config.config) {
    return <Loader />;
  }

  MessageService.send({
    type: globalConfig.postMessage.actions.themeLoaded,
    tintSlug: config.config ? config.config.tintSlug : '',
  });

  const theme = {
    personalization: tintSelector.personalization,
    socialFeeds: tintSelector.socialFeeds,
    meta: tintSelector.meta,
    config: config.config,
    customFontSecondary: tintSelector.customFontSecondary,
    customFontPopup: tintSelector.customFontPopup,
  };

  return (
    <>
      <Head
        isFullscreen={theme.config.fullscreen}
        customCSS={theme.personalization.attributes.data.custom_css}
        fontSecondaryFamily={theme.personalization.attributes.data.font_secondary}
        fontSecondaryUrl={theme.personalization.attributes.data.font_secondary_woff_url}
        customFontSecondary={tintSelector.customFontSecondary}
      />
      <ThemeWrapper theme={theme} />
    </>
  );
};

export default App;
